export interface ProyectoEvntDTO
{
    iddecinvproyectoevnt: number,
    iddecinvproyecto: number,
    iddecinvuser: number,
    nombreUsuario: string,
    tipo: number,
    accion:string,
    comentario: string,
    fechaevnt: Date,
    ultimoCambio: Date,
    yaleido: number,
    url: string, 
    fechacreacion?: Date
}

export function GetVoidProyectoEvntDTO():ProyectoEvntDTO{
    return {
        iddecinvproyectoevnt: 0,
        iddecinvproyecto: 0,
        iddecinvuser: 0,
        nombreUsuario: "",
        tipo: 0,
        accion: "",
        comentario: "",
        fechaevnt: new Date(),
        ultimoCambio: new Date(),
        yaleido: 0,
        url: "", 
        fechacreacion: new Date()
    }
}

export function GetProyectoEvntDTO(iddecinvproyecto:number, iddecinvuser:number, tipo:number, accion:string, comentario:string, url: string):ProyectoEvntDTO{
    let evento: ProyectoEvntDTO = GetVoidProyectoEvntDTO();
    evento.iddecinvproyecto = iddecinvproyecto;
    evento.iddecinvuser = iddecinvuser;
    evento.tipo = tipo;
    evento.accion = accion;
    evento.comentario = comentario;
    evento.url = url;
    return evento;
}

export function SetProyectoEvntDTO(data:any):ProyectoEvntDTO{
    return {
        iddecinvproyectoevnt: data.iddecinvproyectoevnt,
        iddecinvproyecto: data.iddecinvproyecto,
        iddecinvuser: data.iddecinvuser,
        nombreUsuario: data.nombreUsuario,
        tipo: data.tipo,
        accion: data.accion,
        comentario: data.comentario,
        fechaevnt: data.fechaevnt??new Date(),
        ultimoCambio: data.ultimoCambio??new Date(),
        yaleido: data.yaleido??0,
        url: data.url??"", 
        fechacreacion: data.fechacreacion??new Date()
    }
}

export function SetListProyectoEvntDTO(lista:Array<any>):Array<ProyectoEvntDTO>{
    let list: Array<ProyectoEvntDTO> = [];
    lista.forEach((item) => {
        const i: ProyectoEvntDTO = SetProyectoEvntDTO(item)
        list.push(i);
    });
    return list;
}